(function() {
  'use strict';
  
  angular
    .module('plugins.multiple-choice')
    .factory(
      'multipleChoiceResultExportMarkingCsv', 
      multipleChoiceResultExportMarkingCsv
    );
      
  multipleChoiceResultExportMarkingCsv.$inject = [
    '$log', 
    '$filter', 
    '$q', 
    'csvWriter'
  ];
    
  function multipleChoiceResultExportMarkingCsv(
      $log, 
      $filter,
      $q, 
      csvWriter) {
    $log = $log.getInstance('multipleChoiceResultExportMarkingCsv');
    
    return {
      canExportResult: canExportResult,
      exportResults: exportResults
    };

    function canExportResult(result) {
      return result.type === 'multiple-choice';
    }
    
    function exportResults(results) {
      var csv = csvWriter();
      var resultsByPoll = groupResultsByPoll(results);
      var pollIds = [];
      var groupRow = ['GROUP', '', '', ''];
      var pollTextRow = ['POLL TEXT', '', '', ''];
      var correctAnswersRow = ['CORRECT ANSWERS', '', '', ''];
      var finalResponsesByUser = {};
      var userHeaderRow = ['First Name', 'Last Name', 'Username', 'Email'];

      _.each(resultsByPoll, function(pollResults, pollId) {
        var group = _.first(pollResults).group;
        var poll = _.first(pollResults).poll;
        var responses = _.flatten(_.pluck(pollResults, 'responses'));
        var responsesByUser = groupResponsesByUser(responses);
        pollIds.push(pollId);
        groupRow.push(group.name);
        pollTextRow.push(poll.data.question);
        correctAnswersRow.push(getCorrectAnswersString(poll));
        _.each(responsesByUser, function(userResponses, userId) {
          var finalResponse = _.last(userResponses);
          finalResponsesByUser[userId] = finalResponsesByUser[userId] || {};
          finalResponsesByUser[userId][pollId] = finalResponse;
          finalResponsesByUser[userId].$username = finalResponse.user.username;
        });
      });
      // Push total answered and correct to the end of the table
      for (var i = 0; i < correctAnswersRow.length - 4; i++) {
        userHeaderRow.push('');
      }
      userHeaderRow.push('Total Answered');
      userHeaderRow.push('Total Correct');
      
      finalResponsesByUser = _.sortBy(finalResponsesByUser, '$username');
      
      csv.addRow(groupRow);
      csv.addRow(pollTextRow);
      csv.addRow(correctAnswersRow);
      csv.addRow(userHeaderRow);
      
      _.each(finalResponsesByUser, function(userResponses) {
        var userFirstResponce = Object.keys(userResponses)[0];
        var row = [
          userResponses[userFirstResponce].user.name.first,
          userResponses[userFirstResponce].user.name.last,
          userResponses.$username,
          userResponses[userFirstResponce].user.email
        ];
        var totalQuestionsAnswered = 0;
        var totalQuestionsCorrect = 0;
        var correctAnswerIndex = 4; // skip the first 4 cells which are: "CORRECT ANSWERS","","",""
        _.each(pollIds, function(pollId) {
          var response = userResponses[pollId]; 
          row.push(response ? response.data : '');
          if (response !== undefined){
            totalQuestionsAnswered++;
            if(correctAnswersRow[correctAnswerIndex].indexOf(response.data)>-1){
              totalQuestionsCorrect++;
            }
          }
          correctAnswerIndex++
        });
        row.push(totalQuestionsAnswered);
        row.push(totalQuestionsCorrect);
        csv.addRow(row);
      });
      
      return $q.resolve(csv.blob());
    }
   
    function getCorrectAnswersString(poll) {
      return _.map(
        _.where(poll.data.choices, { correct: true }),
        function(choice) {
          return choice.label;
        }
      ).join('');
    }
    
    function groupResponsesByUser(responses) {
      return _.groupBy(responses, function(response) {
        return response.user.username;
      });
    }
    
    function groupResultsByPoll(results) {
      return _.groupBy(results, function(result) {
        return result.poll._id;
      });
    }
  }
  
})();
